<template>
  <div>
    <div class="content d-flex flex-column flex-column-fluid" id="kt_content">
      <div class="subheader py-3 subheader-transparent" id="kt_subheader">
        <div
          class="container d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap"
        >
          <h1 class="pages-title my-1 mr-5">PROFIL VACATAIRE</h1>
        </div>
      </div>

      <div class="d-flex flex-column-fluid">
        <div class="container">
          <form method="POST" enctype="multipart/form-data">
            <div class="row d-flex justify-content-between">
              <div class="col-md-4">
                <h5 class="card-title">
                  Attestation RIB<span style="color: #ee2d41">*</span>
                </h5>
                <div class="card card-custom attestations-files">
                  <div class="card-body py-6 px-6">
                    <div class="attestation-file">
                      <div
                        class="image-input image-input-outline"
                        id="kt_image_1"
                      >
                        <img
                          class="image-input-wrapper"
                          :src="getAttestationRIB()"
                          style="width: 260px; height: 260px"
                          id="oldImage"
                        />
                        <img
                          class="image-input-wrapper"
                          :src="imagePreview"
                          id="newImageDiv"
                          style="width: 260px; height: 260px; display: none"
                        />
                        <label
                          class="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
                          data-action="change"
                          data-toggle="tooltip"
                          title=""
                          data-original-title="Changer attestation RIB"
                          v-show="vacataire.valider != 1"
                        >
                          <i class="fa fa-pen icon-sm text-muted"></i>
                          <input
                            type="file"
                            name="attestation_rib"
                            @change="onImageChange"
                            accept=".png, .jpg, .jpeg"
                          />
                        </label>
                      </div>
                      <div class="btn-actions btn-group">
                        <button
                          type="button"
                          class="btn btn-sm btn-success"
                          id="submit_image"
                          style="display: none"
                          @click="uploadImage()"
                        >
                          modifier
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <h5 class="card-title">
                  Photo<span style="color: #ee2d41">*</span>
                </h5>
                <div class="card card-custom attestations-files">
                  <div class="card-body py-6 px-6">
                    <div class="attestation-file">
                      <div
                        class="image-input image-input-outline"
                        id="kt_image_1"
                      >
                        <img
                          class="image-input-wrapper"
                          :src="getProfilePhoto()"
                          style="width: 260px; height: 260px"
                          id="oldImageProfile"
                        />
                        <img
                          class="image-input-wrapper"
                          :src="imageProfilPreview"
                          id="newImageProfilDiv"
                          style="width: 260px; height: 260px; display: none"
                        />
                        <label
                          class="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
                          data-action="change"
                          data-toggle="tooltip"
                          title=""
                          data-original-title="Changer attestation RIB"
                          v-show="vacataire.valider != 1"
                        >
                          <i class="fa fa-pen icon-sm text-muted"></i>
                          <input
                            type="file"
                            name="photo"
                            @change="onImageProfilChange"
                            accept=".png, .jpg, .jpeg"
                          />
                        </label>
                      </div>
                      <div class="btn-actions btn-group">
                        <button
                          type="button"
                          class="btn btn-sm btn-success"
                          id="submit_image_profile"
                          style="display: none"
                          @click="uploadImageProfil()"
                        >
                          modifier
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="row mt-15">
            <div class="col-lg-12">
              <div
                class="container d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap"
              >
                <h5 class="card-title">INFORMATIONS PERSONNELLES</h5>

                <h5 style="color: #b1bbcb">
                  (<span style="color: #ee2d41">*</span>)champs obligatoires
                </h5>
              </div>
              <div
                class="card card-custom gutter-b example example-compact profile-datas"
              >
                <!--begin::Form-->
                <div class="card-body">
                  <div class="form-group row">
                    <div class="col-lg-4">
                      <h4>{{ vacataire.nom }} {{ vacataire.prenom }}</h4>
                      <p class="separator"></p>
                    </div>
                    <div class="col-lg-4">
                      <label>CIN<span style="color: #ee2d41">*</span></label>
                      <input
                        type="text"
                        name="cin"
                        value="vacataire.cin"
                        v-model="vacataire.cin"
                        class="form-control"
                      />
                    </div>
                    <div class="col-lg-4">
                      <label>PASSPORT</label>
                      <input
                        type="text"
                        name="passport"
                        v-model="vacataire.passport"
                        class="form-control"
                      />
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-lg-4">
                      <label
                        >DATE DE NAISSANCE
                        <span style="color: #ee2d41">*</span>
                      </label>
                      <datepicker
                        v-model="vacataire.date_naissance"
                        name="date_naissance"
                        format="yyyy-MM-dd"
                        bootstrapStyling
                      />
                    </div>
                    <div class="col-lg-4">
                      <label
                        >PAYS D'ORIGINE<span style="color: #ee2d41">* </span>
                      </label>
                      <select
                        name="pays_id"
                        class="selectpicker"
                        data-width="100%"
                        data-live-search="true"
                        v-model="vacataire.pays_id"
                      >
                        <option v-if="vacataire.pays_id == NULL" :value="149">
                          Morocco
                        </option>

                        <option
                          v-for="pay in pays"
                          :key="pay.id"
                          :selected="pay.id == vacataire.pays_id"
                          :value="pay.id"
                        >
                          {{ pay.nom }}
                        </option>
                      </select>
                    </div>
                    <div class="col-lg-4">
                      <label
                        >ADRESSE<span style="color: #ee2d41">*</span></label
                      >
                      <input
                        type="text"
                        name="adresse"
                        v-model="vacataire.adresse"
                        class="form-control"
                      />
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-lg-4">
                      <label>Email personnelle </label>
                      <input
                        type="text"
                        name="email_personnel"
                        v-model="vacataire.email_personnel"
                        class="form-control"
                      />
                    </div>
                    <div class="col-lg-4">
                      <label>EMAIL UIR</label>
                      <input
                        type="text"
                        name="email_uir"
                        v-model="vacataire.email_uir"
                        class="form-control"
                        disabled
                        placeholder="EMAIL UIR"
                      />
                    </div>
                    <div class="col-lg-4">
                      <label
                        >TÉLÉPHONE<span style="color: #ee2d41">*</span></label
                      >
                      <input
                        type="text"
                        name="tel"
                        v-model="vacataire.tel"
                        class="form-control"
                      />
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-lg-6">
                      <label
                        >PROFESSION<span style="color: #ee2d41">*</span></label
                      >
                      <input
                        type="text"
                        name="profession"
                        v-model="vacataire.profession"
                        class="form-control"
                      />
                    </div>
                    <div class="col-lg-6">
                      <label
                        >DERNIER DIPLÔME<span style="color: #ee2d41"
                          >*</span
                        ></label
                      >
                      <input
                        type="text"
                        name="dernier_diplome"
                        v-model="vacataire.dernier_diplome"
                        class="form-control"
                      />
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-lg-3">
                      <label
                        >Secteur<span style="color: #ee2d41">*</span></label
                      >
                      <div class="radio-inline">
                        <label class="radio radio-outline radio-success">
                          <input
                            class="public"
                            type="radio"
                            name="public"
                            :value="1"
                            v-model="vacataire.public"
                          />
                          <span></span>Public
                        </label>
                        <label class="radio radio-outline radio-success">
                          <input
                            class="public"
                            type="radio"
                            name="public"
                            :value="0"
                            v-model="vacataire.public"
                          />
                          <span></span>Privé
                        </label>
                      </div>
                    </div>
                    <div class="col-lg-4" id="engager">
                      <label
                        >Ministère de Tutelle<span style="color: #ee2d41"
                          >*</span
                        ></label
                      >
                      <div class="radio-inline">
                        <label class="radio radio-outline radio-success">
                          <input
                            class="engager"
                            type="radio"
                            name="engager"
                            :value="1"
                            v-model="vacataire.engager"
                          />
                          <span></span>Ministère de l'Enseignement Supérieur
                          (MES)
                        </label>
                        <label class="radio radio-outline radio-success">
                          <input
                            class="engager"
                            type="radio"
                            name="engager"
                            :value="0"
                            v-model="vacataire.engager"
                          />
                          <span></span>Autre
                        </label>
                      </div>
                    </div>
                    <div class="col-lg-5" id="etablissement_origine">
                      <label>ÉTABLISSEMENT D'ORIGINE:</label>
                      <input
                        type="text"
                        name="etablissement_dorigine"
                        v-model="vacataire.etablissement_dorigine"
                        class="form-control"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-15">
            <div class="col-lg-12">
              <h5 class="card-title">INFORMATIONS BANCAIRES</h5>
              <div
                class="card card-custom gutter-b example example-compact profile-datas"
              >
                <div class="card-body">
                  <div class="form-group row">
                    <div class="col-lg-4">
                      <label
                        >NOM BANQUE<span style="color: #ee2d41">*</span></label
                      >
                      <select
                        name="banque"
                        v-model="vacataire.banque"
                        class="selectpicker"
                        data-width="100%"
                        data-live-search="true"
                      >
                        <option
                          :selected="'ARAB BANK MAROC' == vacataire.banque"
                          value="ARAB BANK MAROC"
                        >
                          ARAB BANK MAROC
                        </option>
                        <option
                          :selected="'ATTIJARIWAFA BANK' == vacataire.banque"
                          value="ATTIJARIWAFA BANK"
                        >
                          ATTIJARIWAFA BANK
                        </option>
                        <option
                          :selected="'AL BARID BANK' == vacataire.banque"
                          value="AL BARID BANK"
                        >
                          AL BARID BANK
                        </option>
                        <option
                          :selected="
                            'BANQUE CENTRALE POPULAIRE' == vacataire.banque
                          "
                          value="BANQUE CENTRALE POPULAIRE"
                        >
                          BANQUE CENTRALE POPULAIRE
                        </option>
                        <option
                          :selected="'BANK OF AFRICA' == vacataire.banque"
                          value="BANK OF AFRICA"
                        >
                          BANK OF AFRICA
                        </option>
                        <option
                          :selected="'BMCI' == vacataire.banque"
                          value="BMCI"
                        >
                          BMCI
                        </option>
                        <option
                          :selected="'BMCE' == vacataire.banque"
                          value="BMCE"
                        >
                          BMCE
                        </option>
                        <option
                          :selected="'CAIXA BANK' == vacataire.banque"
                          value="CAIXA BANK"
                        >
                          CAIXA BANK
                        </option>
                        <option
                          :selected="
                            'CREDIT AGRICOLE DU MAROC' == vacataire.banque
                          "
                          value="CREDIT AGRICOLE DU MAROC"
                        >
                          CREDIT AGRICOLE DU MAROC
                        </option>
                        <option
                          :selected="'CFG BANK' == vacataire.banque"
                          value="CFG BANK"
                        >
                          CFG BANK
                        </option>
                        <option
                          :selected="'CDG CAPITAL' == vacataire.banque"
                          value="CDG CAPITAL"
                        >
                          CDG CAPITAL
                        </option>
                        <option
                          :selected="'CIH' == vacataire.banque"
                          value="CIH"
                        >
                          CIH
                        </option>
                        <option
                          :selected="'CITIBANK MAGHREB' == vacataire.banque"
                          value="CITIBANK MAGHREB"
                        >
                          CITIBANK MAGHREB
                        </option>
                        <option
                          :selected="'CREDIT DU MAROC' == vacataire.banque"
                          value="CREDIT DU MAROC"
                        >
                          CREDIT DU MAROC
                        </option>
                        <option
                          :selected="'SABADEL' == vacataire.banque"
                          value="SABADEL"
                        >
                          SABADEL
                        </option>
                        <option
                          :selected="
                            'SOCIETE GENERALE MAROCAINE DE BANQUES' ==
                            vacataire.banque
                          "
                          value="SOCIETE GENERALE MAROCAINE DE BANQUES"
                        >
                          SOCIETE GENERALE MAROCAINE DE BANQUES
                        </option>
                        <option
                          :selected="
                            'UNION MAROCAINE DES BANQUES' == vacataire.banque
                          "
                          value="UNION MAROCAINE DES BANQUES"
                        >
                          UNION MAROCAINE DES BANQUES
                        </option>
                        <option
                          :selected="'Bank Assafa' == vacataire.banque"
                          value="Bank Assafa"
                        >
                          Bank Assafa
                        </option>
                        <option
                          :selected="'Autre' == vacataire.banque"
                          value="Autre"
                        >
                          Autre
                        </option>
                      </select>
                    </div>
                    <div class="col-lg-4">
                      <label>SWIFT</label>
                      <input
                        type="text"
                        name="swift"
                        v-model="vacataire.swift"
                        class="form-control"
                      />
                    </div>
                    <div class="col-lg-4">
                      <label>IBAN</label>
                      <input
                        type="text"
                        name="iban"
                        v-model="vacataire.iban"
                        class="form-control"
                      />
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-lg-12">
                      <label>RIB<span style="color: #ee2d41">*</span></label>
                      <input
                        type="text"
                        name="rib"
                        v-model="vacataire.rib"
                        class="form-control"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4"></div>
            <div class="col-md-4"></div>

            <div class="col-md-4">
              <button
                v-show="vacataire.valider == 0"
                type="submit"
                @click="updateVacataire()"
                class="submit-btn pl-12 pr-12 float-right btn btn-lg"
              >
                <i class="fas fa-check"></i> ENREGISTRER
              </button>
            </div>
          </div>
        </div>
        <!--end::Container-->
      </div>
      <!--end::Entry-->
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
export default {
  components: {
    Datepicker,
  },
  props: {
    vacataire: {},
    pays: {},
  },
  data() {
    return {
      image: null,
      imageProfil: null,
      imagePreview: null,
      imageProfilPreview: null,
    };
  },
  watch: {
    rib(newImage, oldImage) {
      var x = document.getElementById("submit_image");
      if (newImage != "") {
        x.style.display = "block";
      }
    },
  },
  methods: {
    getProfilePhoto() {
      var photo =
        this.vacataire.image_path == null
          ? "/images/avatar.png"
          : "/" + this.vacataire.image_path;
      return photo;
    },
    getAttestationRIB() {
      var photo =
        this.vacataire.attestation_rib_path == null
          ? "/images/document.png"
          : "/" + this.vacataire.attestation_rib_path;

      return photo;
    },

    onImageChange(e) {
      var x = document.getElementById("submit_image");
      x.style.display = "block";

      var old = document.getElementById("oldImage");
      old.style.display = "none";

      var newI = document.getElementById("newImageDiv");
      newI.style.display = "block";

      this.image = e.target.files[0];
      console.log(this.image);
      let reader = new FileReader();
      reader.readAsDataURL(this.image);
      reader.onload = (e) => {
        this.imagePreview = e.target.result;
      };
    },

    onImageProfilChange(e) {
      var xa = document.getElementById("submit_image_profile");
      xa.style.display = "block";

      var oldP = document.getElementById("oldImageProfile");
      oldP.style.display = "none";

      var newIP = document.getElementById("newImageProfilDiv");
      newIP.style.display = "block";

      this.imageProfil = e.target.files[0];
      console.log(this.imageProfil);
      let readerP = new FileReader();
      readerP.readAsDataURL(this.imageProfil);
      readerP.onload = (e) => {
        this.imageProfilPreview = e.target.result;
      };
    },
    uploadImage() {
      let data = new FormData();
      data.append("vacataire_id", this.vacataire.id);
      data.append("attestation_rib", this.image);
      axios
        .post("/api/upload/attestation_rib", data)
        .then((response) => {
          var submitBTN = document.getElementById("submit_image");
          submitBTN.style.display = "none";

          this.vacataire.attestation_rib_path =
            response.data.attestation_rib_path;

          Vue.swal.fire({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true,
            title: "Attestation RIB modifié avec succès!",
            icon: "success",
            confirmButtonText: "Cool",
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    uploadImageProfil() {
      let dataP = new FormData();
      dataP.append("vacataire_id", this.vacataire.id);
      dataP.append("photo", this.imageProfil);
      axios
        .post("/api/upload/photo_profile", dataP)
        .then((response) => {
          var submitBTNP = document.getElementById("submit_image_profile");
          submitBTNP.style.display = "none";

          Vue.swal.fire({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true,
            title: "Photo de profile modifié avec succès!",
            icon: "success",
            confirmButtonText: "Cool",
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    updateVacataire() {
      if (this.vacataire.attestation_rib_path != null) {
        axios
          .put("/api/vacataire/update", {
            vacataire_id: this.vacataire.id,
            cin: this.vacataire.cin,
            passport: this.vacataire.passport,
            date_naissance: moment(this.vacataire.date_naissance).format(
              "yyyy-MM-DD"
            ),
            pays_id: this.vacataire.pays_id,
            adresse: this.vacataire.adresse,
            email_personnel: this.vacataire.email_personnel,
            email_uir: this.vacataire.email_uir,
            tel: this.vacataire.tel,
            profession: this.vacataire.profession,
            dernier_diplome: this.vacataire.dernier_diplome,
            engager: this.vacataire.engager,
            public: this.vacataire.public,
            banque: this.vacataire.banque,
            swift: this.vacataire.swift,
            iban: this.vacataire.iban,
            rib: this.vacataire.rib,
            etablissement_dorigine: this.vacataire.etablissement_dorigine,
          })
          .then((response) => {
            this.vacataire.valider = response.data.valider;

            Vue.swal.fire({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 4000,
              timerProgressBar: true,
              title: "profile vacataire modifié avec succès!",
              icon: "success",
              confirmButtonText: "Cool",
            });
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        Vue.swal.fire({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 4000,
          timerProgressBar: true,
          title: "Veuillez uploader l'attestation de RIB avant de valider!",
          icon: "error",
          confirmButtonText: "Cool",
        });
      }
    },
  },
  mounted() {},
};
</script>


